<!-- envioFormComponent.vue -->
<template>
    <div class="envio-form-container">  
      <!-- Diálogo del formulario -->
      <dialog :open="show" class="envio-dialog">
        <div class="dialog-content">          
          <form @submit.prevent="submitForm">
            <div class="row mt-2">
              <div class="col-md-3">
                <div class="form-group" v-if="formData.id">
                  <label class="form-label">ID: {{ formData.id }}</label>
                </div>
                
                <!-- Campo de búsqueda para expendeduría -->
                <div class="form-group">
                  <label class="form-label">Expendeduría:</label>
                  <search-select
                    :reset-trigger="!show"
                    :items="expendeduriasResults"
                    :loading="loadingExpendedurias"
                    :initial-value="expendeduriaInitialValue"
                    item-text="name"
                    @search="handleExpendeduriaSearch"
                    @select="selectExpendeduria"
                    placeholder="Buscar expendeduría..."
                    ref="expendeduriaSelect"
                  />
                </div>
              </div>
  
              <!-- Selector de operador -->
              <div class="col-md-3">
                <label class="form-label">Operador:</label>
                <select class="form-select form-select-sm p-1" v-model="formData.id_operator">
                  <option 
                    v-for="operator in operators"
                    :key="operator.id"
                    :value="operator.id"
                  >
                    {{ operator.name }}
                  </option>
                </select>
              </div>

              <!-- ID CV -->
              <div class="col-md-3 form-group">
                <label class="form-label">ID Pedido (Opcional)</label>
                <div class="input-group">
                  <input
                    v-model="formData.id_pedido_cv"
                    type="number"
                    maxlength="5"
                    class="form-control"
                    placeholder="N° Pedido"
                  />
                  <button @click="handlePedidoSearch(formData.id_pedido_cv)"
                    :disabled="pedidoStore.isLoading"
                    class="btn btn-outline-secondary" type="button"
                  >
                    <i v-if="!pedidoStore.isLoading" class="search-icon">🔍</i>
                  </button>

                  <transition name="fade">
                    <div 
                    v-if="pedidoStore.error || pedidoStore.lastResult"
                    class="import-feedback"
                    :class="{ 'error': pedidoStore.error, 'success': pedidoStore.lastResult }"
                    >
                      <span v-if="pedidoStore.error">❌ <!-- {{ pedidoStore.error }} --></span>
                      <span v-else-if="pedidoStore.lastResult">✅</span>
                    </div>
                  </transition>
                </div>
                  
              </div>
              
              <!-- ESTADO -->
              <div class="col-md-3">
                <label class="form-label">Estado: </label>
                <select class="form-select form-select-sm p-1" v-model="formData.status">
                  <option value="" disabled selected>Seleccione un estado</option>
                  <option 
                    v-for="status in statusOptions"
                    :key="status.value"
                    :value="status.value"
                  >
                    {{ status.label }}
                  </option>
                </select>
              </div>
            </div>


            <div class="row">
              <!-- Checkbox for return -->
              <div class="col-3">
                <div class="form-check">
                  <input 
                    class="form-check-input"
                    type="checkbox"
                    v-model="formData.with_return"
                    id="withReturn"
                  />
                  <label class="form-check-label" for="withReturn">
                    Incluye retorno
                  </label>
                </div>
              </div>
              
              <div v-if="formData.with_return" class="col-3">
                <div class="btn-group">
                  <button
                    type="button"
                    :class="['btn', currentMode === 'envio' ? 'btn-dark' : 'btn-outline-dark']" 
                    @click="currentMode = 'envio'"
                  >
                    Envío
                  </button>
                  <button
                    type="button"
                    :class="['btn', currentMode === 'retorno' ? 'btn-dark' : 'btn-outline-dark']" 
                    @click="currentMode = 'retorno'"
                  >
                    Retorno
                  </button>
                </div>
              </div>

              <div v-if="formData.with_return" class="col-3">
                <label class="form-label">Día de retorno:</label>
                <input 
                  type="date"
                  class="form-control"
                  v-model="formData.date_return"
                />
              </div>
            </div>

            <!-- Lista de productos organizada en 4 columnas -->
            <div class="row mt-4">
              <div class="col-12">
                <!-- <h5 class="mb-3">Productos para el Envío</h5> -->
                <h5 v-if="currentMode==='envio'">Productos para el Envío</h5>
                <h5 v-else>Productos para el Retorno</h5>
                
                <div class="row">
                  <!-- Iterar sobre las categorías -->
                  <div class="col-md-3" v-for="categoria in productosPorCategoria" :key="categoria.nombre">
                    <h6 class="bg-light p-2">{{ categoria.nombre }}</h6>
                    <div class="producto-item" v-for="producto in categoria.productos" :key="producto.id" :class="{'resaltado': formData.cantidades[currentMode][producto.id] > 0, 'resaltado-negativo': formData.cantidades[currentMode][producto.id] < 0}">
                      <div class="d-flex align-items-center justify-content-between">
                        <label class="form-check-label mb-0 flex-grow-1" :for="'cantidad-' + producto.id">
                          {{ producto.nombre }}
                        </label>
                        <input 
                          type="number" 
                          v-model.number="formData.cantidades[currentMode][producto.id]"
                          class="form-control form-control-sm cantidad-input"
                          style="background-color: transparent;"
                          :id="'cantidad-' + producto.id"
                          placeholder="0"
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Descripción -->
            <div class="form-group mt-4">
              <label class="form-label">Descripción:</label>
              <textarea
                v-model="formData.description"
                rows="4"
              ></textarea>
            </div>
  
            <!-- Acciones -->
            <div class="form-actions">
              <button 
                type="button"
                @click="closeDialog"
                class="cancel-btn"
              >
                Cancelar
              </button>
              <button 
                type="submit"
                :disabled="submitting"
                class="btn btn-dark"
              >
                <span v-if="submitting">Guardando...</span>
                <span v-else>Guardar Envio</span>
              </button>
            </div>
          </form>
        </div>
      </dialog>
    </div>
  </template>
  
  <script setup lang="ts">
  import { ref, reactive, onMounted, watch, nextTick, computed } from 'vue';
  import { useEnviosStore } from '@/stores/useEnvioStore';
  import { storeToRefs } from 'pinia';
  //import axios from 'axios';
  import _ from 'lodash';
  import entitiesAPI from '@/api/entitiesAPI';
  import usersAPI from '@/api/usersAPI';
  import SearchSelect from './SearchSelect.vue';
  import type { Envio } from '@/types/envioTypes';
  import { usePedidoStore } from '@/stores/usePedidoStore';

  const envioStore = useEnviosStore();
  const pedidoStore = usePedidoStore();

  const showDialog = ref(false);
  const submitting = ref(false);
  const operators = ref<Operator[]>([]);

  const currentMode = ref<'envio' | 'retorno'>('envio');

  // Definir los productos según la estructura que proporcionaste
  const productosPorCategoria = ref([
    {
      nombre: 'Modems',
      productos: [
        { id: 4, nombre: 'Sim Conexa' },
        { id: 5, nombre: 'Sim Movistar' },
        { id: 2, nombre: 'Modem Altadis' },
        { id: 3, nombre: 'Modem CV' },
        { id: 6, nombre: 'Cables Jof 6 Dig' },
        { id: 7, nombre: 'Cables Jof 4 Dig' },
        { id: 8, nombre: 'Cables GM 6 Dig' },
        { id: 9, nombre: 'Cables GM 4 Dig' },
        { id: 10, nombre: 'Cables Azk' },
        { id: 11, nombre: 'Micro' },
        { id: 12, nombre: 'Cables Jof 6 Dig Antiguo' },
        { id: 13, nombre: 'Sim COM4' }
      ]
    },
    {
      nombre: 'Grupo QPay',
      productos: [
        { id: 18, nombre: 'Qpay Libre' },
        { id: 19, nombre: 'Atax' },
        { id: 20, nombre: 'MDB Atax' },
        { id: 21, nombre: 'Tornillos' },
        { id: 22, nombre: 'Arandelas' },
        { id: 23, nombre: 'Funda Qpay' },
        { id: 24, nombre: 'Pegatinas Agujero Qpay' },
        { id: 25, nombre: 'Cajas ATAX' }
      ]
    },
    {
      nombre: 'Grupo Ingénico',
      productos: [
        { id: 14, nombre: 'Ingenico Libre' },
        { id: 15, nombre: 'Raspberry' },
        { id: 16, nombre: 'MDB Raspberry' },
        { id: 17, nombre: 'Pegatina Agujero Ingénico' }
      ]
    },
    {
      nombre: 'Grupo Sueltos',
      productos: [
        { id: 26, nombre: 'Antena' },
        { id: 27, nombre: 'SIM Telenor' },
        { id: 28, nombre: 'Pegatina Instrucciones' },
        { id: 29, nombre: 'Módulo Ingénico' },
        { id: 30, nombre: 'Módulo Wifi' },
        { id: 31, nombre: 'Adaptador MDB' },
        { id: 32, nombre: 'Cable USB' }
      ]
    }
  ]);

  const formatDate = (date: string | Date | null): string | null => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handlePedidoSearch = async (pedidoId: number | null) => {
    console.log("PEDIDO ID: ", pedidoId)
    if (pedidoId) {
      const response = await pedidoStore.startSearch(pedidoId);

      formData.id_expendeduria = response.id_expendeduria

      /* expendeduriaInitialValue.value = {
        id: response.id_expendeduria,
        name: response.expendeduria_nombre
      } */

      expendeduriaInitialValue.value = response.expendeduria_nombre

      for (const key in formData.cantidades.envio) {
        formData.cantidades.envio[key] = 0
      }

      if (response) {
        for (let key in response.productos_necesarios) {
          const productId = Number(key)
          formData.cantidades.envio[productId] = response.productos_necesarios[key]
        }
      }
    }
  };

  // Computed para obtener todos los productos en un solo array (si es necesario)
  const todosLosProductos = computed(() => {
    return productosPorCategoria.value.flatMap(categoria => categoria.productos);
  });

  type SearchSelectInstance = {
    resetInput: () => void;
    // Agrega otros métodos si los necesitas
  };

  const expendeduriaInitialValue = ref('');
  const expendeduriaSelect = ref<SearchSelectInstance | null>(null);

  const props = defineProps<{
    show: boolean;
    envio?: Envio | null;
  }>();

  const emit = defineEmits<{
    (e: 'close'): void
    (e: 'submitted'): void
  }>();
  
  // Eliminar showDialog y usar prop
  watch(() => props.show, (newVal) => {
    if (!newVal) resetForm();
  });

  // Modificar métodos de cierre y envío
  const closeDialog = () => {
    emit('close');
  };


  // Estado del formulario
  const formData = reactive({
    id: null as number | null,
    id_expendeduria: null as number | null,
    id_operator: null as number | null,
    status: null as string | null,
    description: ''   as string | null,
    id_pedido_cv: null as number | null,
    with_return: false as boolean,
    date_return: '' as string | null,
    cantidades: {
      envio: {} as Record<number, number>, // ID - cantidad
      retorno: {} as Record<number, number>
    }
  });

  // Inicializar todas las cantidades en 0
  const inicializarCantidades = () => {
    productosPorCategoria.value.forEach(categoria => {
      categoria.productos.forEach(producto => {
        if (formData.cantidades.envio[producto.id] === undefined) {
          formData.cantidades.envio[producto.id] = 0;
        }
      });
    });
  };

  
  // Lista de operadores
  interface Operator {
    id: number | string;
    name: string;
  }

  const statusOptions = ref([
    { value: 'pendiente', label: 'Pendiente' },
    { value: 'enviado', label: 'Enviado' },
    { value: 'cancelado', label: 'Cancelado' }
  ]);

  const operatorsLoaded = ref(false);
  const operatorsError = ref(false);
  const loadingOperators = ref(false);

  watch(() => props.show, async (visible) => {
    if (visible) {
      // Solo resetea si NO estamos editando un envio existente
      if (!props.envio) {
        resetForm();
      }/*  else {
        inicializarCantidades();
      } */
      
      // Cargar operadores solo si no se han cargado antes y no hay error
      if (!operatorsLoaded.value && !operatorsError.value && !loadingOperators.value) {
        await loadOperators();
      }

      if (props.envio) {
        await loadEnvioData(props.envio);
      }

      // Solo resetear los inputs si no estamos editando
      await nextTick();
      if (!props.envio) {
        expendeduriaSelect.value?.resetInput();
      }
    }
  });

  // Búsqueda de expendedurías
  const expendeduriasResults = ref<any[]>([]);
  const loadingExpendedurias = ref(false);
  const handleExpendeduriaSearch = _.debounce(async (query: string) => {
    if (query === "") {
      expendeduriasResults.value = [];
      return
    }
    
    try {
      loadingExpendedurias.value = true;
      const response = await entitiesAPI.searchExpendeduria(query);
      expendeduriasResults.value = response.results.slice(0, 10);
    } catch (error) {
      console.error('Error buscando expendedurías:', error);
    } finally {
      loadingExpendedurias.value = false;
    }
  }, 500);
  
  const selectExpendeduria = (item: any) => {
    formData.id_expendeduria = item.id;
  };
  
 
  
  // Envío del formulario
  const submitForm = async () => {
    if (!formData.id_operator) {
      alert('Por favor selecciona un operador');
      return;
    }

    if (!formData.status) {
      alert('Por favor selecciona el estado del envio')
    }

/*     // Validar que al menos un producto tenga cantidad mayor a 0
    const hasProducts = Object.values(formData.cantidades).some(cantidad => cantidad > 0);
    if (!hasProducts) {
      alert('Por favor ingresa al menos una cantidad mayor a 0 para algún producto');
      return;
    } */

    submitting.value = true;
    
    try {
      // Preparar detalles del envío
      /* const cantidades = Object.entries(formData.cantidades.envio)
      .filter(([_, cantidad]) => cantidad != 0)
      .map(([idProducto, cantidad]) => ({
        id_producto: parseInt(idProducto),
        cantidad: Number(cantidad)
      }));
       */
      const cantidades = [
        ...Object.entries(formData.cantidades.envio)
          .filter(([_, cantidad]) => cantidad !== 0)
          .map(([idProducto, cantidad]) => ({
            id_producto: parseInt(idProducto),
            cantidad: Number(cantidad),
            tipo: "envio"
          })),
        ...Object.entries(formData.cantidades.retorno)
          .filter(([_, cantidad]) => cantidad !== 0)
          .map(([idProducto, cantidad]) => ({
            id_producto: parseInt(idProducto),
            cantidad: Number(cantidad),
            tipo: "retorno"
          }))
      ];

      const payload = {
        id_operator: formData.id_operator,
        id_expendeduria: formData.id_expendeduria,
        status: formData.status,
        description: formData.description,
        id_pedido_cv: formData.id_pedido_cv,
        with_return: formData.with_return,
        date_return: formatDate(formData.date_return),
        cantidades: cantidades
      };

      console.log("PAYLOAD:")
      console.log(payload)

      // Agregar id_expendeduria solo si tiene valor
      if (formData.id_expendeduria) {
          payload.id_expendeduria = formData.id_expendeduria;
      }


      if (formData.id) {
        // modo edición
        await envioStore.updateEnvio(formData.id, payload)
      } else {
        // modo creación
        await envioStore.createEnvio(payload);
      }

      emit('submitted')
      emit('close')
      resetForm();
    } catch (error) {
      console.error('Error creando o editanto envio:', error);
      alert('Error al guardar o editar el envio');
    } finally {
      submitting.value = false;
    }
  };
  
  const resetForm = () => {
    formData.id = null;
    formData.id_expendeduria = null;
    formData.id_operator = null;
    formData.status = "enviado";
    formData.description = '';
    formData.with_return = false;
    formData.cantidades.envio = {};
    formData.cantidades.retorno = {};
    
    currentMode.value = 'envio'

    inicializarCantidades();

    expendeduriasResults.value = [];
    handleExpendeduriaSearch.cancel();
    expendeduriaInitialValue.value = "";
  };

  watch(() => formData.id_operator, (newVal) => {
    console.log('Operador seleccionado:', newVal);
  });


  watch(() => props.show, async (visible) => {
    if (visible) {
      if (!props.envio) {
        resetForm();
      }
      
      if (operators.value.length === 0) {
        await loadOperators();
      }

      if (props.envio) {
        await loadEnvioData(props.envio);
      }

      // Solo resetear los inputs si no estamos editando
      await nextTick();
      if (!props.envio) {
        expendeduriaSelect.value?.resetInput();
      }

      // Limpiar físicamente los inputs
      /* setTimeout(() => {
        const inputs = document.querySelectorAll('.search-select input');
        inputs.forEach(input => (input as HTMLInputElement).value = '');
      }, 50); */
    }
  });

  /* const loadOperators = async () => {
    try {
      const response = await usersAPI.getOperators();
      operators.value = response.results.map((operator: any) => ({
        id: Number(operator.id),
        name: operator.username || 'Sin nombre' // Manejar casos null
      }));
    } catch (error) {
      console.error('Error cargando operadores:', error);
      alert('Error al cargar operadores');
    }
  }; */

  const loadOperators = async () => {
    loadingOperators.value = true;
    try {
      const response = await usersAPI.getOperators();
      operators.value = response.results.map((operator: any) => ({
        id: Number(operator.id),
        name: operator.username || 'Sin nombre'
      }));
      operatorsLoaded.value = true;
      operatorsError.value = false;
    } catch (error) {
      console.error('Error cargando operadores:', error);
      operatorsError.value = true;
    } finally {
      loadingOperators.value = false;
    }
  };


  const loadEnvioData = async (envio: Envio) => {    
    formData.id = envio.id;
    formData.id_expendeduria = envio.id_expendeduria;
    formData.id_operator = envio.id_operator;
    formData.status = envio.status;
    formData.description = envio.description;
    formData.id_pedido_cv = envio.id_pedido_cv;
    formData.with_return = envio.with_return || false;

    inicializarCantidades();

    console.log("ESTAMOS EN INICIALIZAR CANTIDADESSSSSSSSSSSSSSSSSSSSSss")
    console.log(envio.detalles)

    // Cargar productos seleccionados y cantidades si estamos editando
    if (envio.detalles && Array.isArray(envio.detalles)) {
      envio.detalles.forEach(d => {
        formData.cantidades.envio[d.id_producto] = d.cantidad;
      });

      console.log("FORM DATAAAAAAAAAAAAAAAAaaa")
      console.log(formData.cantidades)
    }

    // Establecer valores iniciales para los campos de búsqueda
    expendeduriaInitialValue.value = envio.expendeduria_nombre || '';

    // Forzar la actualización de los componentes SearchSelect
    /* await nextTick();
    if (expendeduriaSelect.value) {
      expendeduriaSelect.value.resetInput();
    }
    if (maquinaSelect.value) {
      maquinaSelect.value.resetInput();
    } */
  }
  inicializarCantidades();
</script>


<style scoped>
  .envio-form-container {
    position: relative;
  }
    
  .envio-dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: min(130vw, 1200px);
    background: white;
    border-radius: 8px;
    padding: 2rem;
    box-shadow: 0 0 20px rgba(0,0,0,0.2);
    border: none;
    z-index: 1000;
    /* background: white; */
    animation: dialogEnter 0.3s ease;
  }

  .resaltado {
    background-color: #fcf75e; /* verde suave */
  }

  .resaltado-negativo {
    background-color: coral;
  }

  /* .envio-dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
  } */
  
  .dialog-content h2 {
    margin-top: 0;
    color: #333;
    border-bottom: 2px solid #eee;
    padding-bottom: 1rem;
  }
  
  .form-group {
    margin-bottom: 1.5rem;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 0.5rem;
    /* color: #666; */
    font-weight: 500;
  }

  .input-group {
  display: flex;
  }

  .input-group .form-control {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    flex: 1;
  }

  .input-group .btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    white-space: nowrap;
  }

  .search-icon {
    font-size: 1rem;
  }

  .producto-item {
    border-bottom: 1px solid #eee;
  }

  .producto-item:last-child {
    border-bottom: none;
  }

  .cantidad-input {
    width: 70px !important;
    min-width: 70px;
    margin-left: 0.5rem;
  }


  .form-check {
    margin-bottom: 0;
  }
  
  input[type="text"],
  input[type="tel"],
  select,
  textarea {
    width: 100%;
    padding: 0.8rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 1rem;
  }
  
  .checkbox-group {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .checkbox-group input {
    width: auto;
  }
  
  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 2rem;
  }
  
  .submit-btn {
    background: #4caf50;
    color: white;
    padding: 0.8rem 1.5rem;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .submit-btn:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
  
  .cancel-btn {
    background: #f44336;
    color: white;
    padding: 0.8rem 1.5rem;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  @keyframes dialogEnter {
    from {
      opacity: 0;
      transform: translate(-50%, -45%);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }

  /* Responsive adjustments */
@media (max-width: 768px) {
  .envio-dialog {
    width: 95vw;
    padding: 1rem;
  }
  
  .row {
    flex-direction: column;
  }
  
  .col-md-3 {
    width: 100%;
    margin-bottom: 1rem;
  }
  
  .cantidad-input {
    width: 60px !important;
    min-width: 60px;
  }
  
  .form-actions {
    flex-direction: column;
  }

  .return-section {
  background-color: #f8f9fa; /* gris claro */
  border-left: 4px solid #343a40; /* barra lateral para resaltar */
  padding: 1rem;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}

.return-section .btn-group .btn {
  min-width: 80px;
}

.return-section label {
  font-size: 0.9rem;
  color: #495057;
}
}
</style>